import React from "react";
import classnames from "classnames";
import defaultImageAdapter from "theme/components/atoms/Image/adapters/front-commerce";

export const PLACEHOLDER = "/images/resized/placeholder.jpg";
export const ERROR = "/images/resized/error.jpg";

/**
 * @deprecated this will be removed in v3, use getSupportedFormats in ImageAdapter instead ([see documentation](https://developers.front-commerce.com/docs/2.x/advanced/images-adapters/custom-adapter#changing-the-generated-sources-for-srcset))
 */
export const transparentExtensions =
  defaultImageAdapter.getSupportedExtensions(true);
/**
 * @deprecated  this will be removed in v3, use getSupportedFormats in ImageAdapter instead ([see documentation](https://developers.front-commerce.com/docs/2.x/advanced/images-adapters/custom-adapter#changing-the-generated-sources-for-srcset))
 */
export const extensions = defaultImageAdapter.getSupportedExtensions(false);
/**
 * @deprecated  this will be removed in v3, use defaultExtension in ImageAdapter instead ([see documentation](https://developers.front-commerce.com/docs/2.x/advanced/images-adapters/custom-adapter#changing-the-generated-sources-for-srcset))
 */
export const defaultExtension = defaultImageAdapter.getDefaultExtension();

const Picture = ({ src, sources, alt, sizes, preload, ...props }) =>
  sources ? (
    <picture>
      {sources?.map((sourceProps, index) => (
        <source
          key={sourceProps.type || index}
          {...sourceProps}
          sizes={sizes}
        />
      ))}
      <img
        src={src}
        alt={alt}
        {...props}
        loading={preload ? "eager" : "lazy"}
        {...(preload ? { fetchpriority: "high" } : {})}
        decoding={preload ? "sync" : "async"}
      />
    </picture>
  ) : (
    <img src={src} alt={alt} {...props} />
  );

/**
 * @typedef {any} TODO_TypeDef
 *
 * @typedef {TODO_TypeDef} PictureProps
 *
 * @typedef {object} ImageComponentProps
 * @property {any} images
 * @property {any} imgProps
 * @property {number} ratio
 * @property {string} status
 */

const ImageComponent = React.forwardRef(
  (
    /** @type {PictureProps & ImageComponentProps} */
    {
      images,
      alt,
      sizes,
      appearance,
      cover,
      imgProps,
      ratio,
      status,
      dangerouslyDisableLazyLoad,
      preload,
    },
    ref
  ) => {
    const classes = classnames("responsive-image", {
      [`responsive-image--${appearance}`]: appearance,
      [`responsive-image--done`]: status === "done",
      [`responsive-image--error`]: status === "error",
      [`responsive-image--loading`]: status === "loading" || status === "lazy",
      [`responsive-image--preloaded`]: preload,
      "responsive-image--cover": cover,
    });

    return (
      <div
        ref={ref}
        className={classes}
        style={
          ratio
            ? { "--image-ratio": `${(ratio * 100).toFixed(0)}%` }
            : undefined
        }
      >
        <Picture
          {...imgProps}
          /* by using the "done" image here, this is how we're triggering the "load" event on the image */
          {...(preload
            ? images.done
            : images[status === "loading" ? "done" : status])}
          className="responsive-image__actual"
          alt={alt}
          sizes={sizes}
          preload={preload}
        />
        {!dangerouslyDisableLazyLoad && !preload && (
          <Picture
            {...images.loading}
            className="responsive-image__placeholder"
            alt={status === "loading" ? "Loading" : ""}
            sizes={sizes}
          />
        )}
      </div>
    );
  }
);

export default ImageComponent;
